import React from 'react';
import { faTirePressureWarning } from '@fortawesome/pro-solid-svg-icons/faTirePressureWarning';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TirePressureWarningSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTirePressureWarning} {...props} />;
}
